const layout = {
   labelCol: { span: 6 },
   wrapperCol: { span: 18 }
};

export default layout;
